<template>
  <img :src="src" alt="scan" @click="$emit('click')" />
</template>

<script>
import lightSrc from '@/assets/common/scan-w.svg';
import darkSrc from '@/assets/common/scan.svg';

export default {
  name: 'ScanCode',
  props: {
    light: Boolean,
  },
  computed: {
    src() {
      return this.light ? lightSrc : darkSrc;
    },
  },
};
</script>
